import React, { useEffect, useState } from "react";
import { HeaderBox } from "./MobileBookPage";
import { Avatar, IconButton, Snackbar, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowBackIos } from "@mui/icons-material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import YouTube from "react-youtube";
import { useTranslation } from "react-i18next";
import VideosService from "../../Services/VideoPlayer";
import i18n, { _get_i18Lang } from '../../i18n';
import { Modal, Paper, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import gitasevalogo from "../../Images/Image/untitled folder/AppIcon.appiconset/AppIcon copy.png";
import favourite from "../../Images/Image/iconLike.png";
import share from "../../Images/Image/iconShare.png";
import whatsapp from "../../Images/Image/whatsapp.png";
// import Favempty from "";
import Favfill from "../../assets/img/favadd.svg";
import { useVideo } from "../../Contexts/VideosContext";
import { useDownloadApp } from "../../Contexts/DownloadAppContext";
const MbAllVideos = () => {
  const navigate = useNavigate();
  const { setShowDownloadPopup } = useDownloadApp();
  const [videos, setVideos] = useState<any>([]);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [videoId, setVideoId] = useState<any>();
  const [videoTitle, setVideoTitle] = useState<string>("");
  const [videoObjId, setVideoObjId] = useState<any>();
  const [snackOpen, setSnackOpen] = useState(false);
  const { t } = useTranslation();
  const location: any = useLocation();
  const {isLiked,setLikedMsg,setIsLiked,likedMsg}=useVideo();
  useEffect(() => {
  if (likedMsg !== null) {
    setSnackOpen(true);
  }
}, [likedMsg]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const language = _get_i18Lang();
        const response: any = await VideosService.getMbCategories(
          language,
          "",
          location?.state?.id
        );
        if (response.result) {
          setVideos(response.result[0].items);
          console.log(response.result, "result======");
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [location?.state?.id, i18n.language]);

  // const handleFavouriteClick=async()=>{
  //   debugger;
  //  console.log("videoId",videoObjId);
  //   try {
  //     const response = await VideosService.addFavourite(videoObjId);
  //     if(response){ 
  //       console.log("Added to favourite");
  //     }     

  //   } catch (error) {
  //     console.log(error);
  //   }}  

    const handleFavouriteClick = async () => {
      // debugger;
      try {
        if (isLiked) {
          await
            VideosService.removeFavourite(videoObjId);
          setLikedMsg(false);
        } else {
          // await AudiosService.addFavourite(videoObjId);
          await VideosService.addFavourite(videoObjId)
          setLikedMsg(true);
        }
        setIsLiked(!isLiked);
        setTimeout(() => {
          setLikedMsg(null);
        }, 3000);
      } catch (error) {
        console.error("Error updating favourite:", error);
      }
    };
                              
  return (
    <>
      <HeaderBox>
        <IconButton
          onClick={() => navigate(-1)}
          sx={{ position: "absolute", left: 16, top: 35, p: 0 }}
        >
          <ArrowBackIos sx={{ color: "white", fontSize: "18px" }} />
        </IconButton>
        <IconButton
          onClick={() => navigate("/")}
          sx={{ position: "absolute", left: 48, top: 35, p: 0 }}
        >
          <HomeOutlinedIcon sx={{ color: "white", fontSize: "24px" }} />
        </IconButton>

        <Typography
          variant="caption"
          sx={{ color: "#ffffffdd", opacity: 0.9, mb: 0.5 }}
        >
          {t("shrihari_tr")}
        </Typography>

        <Typography
          variant="h6"
          sx={{ color: "#ffffffdd", opacity: 0.9, fontSize: 15 }}
        >
          {t("Video_tr")}
        </Typography>
      </HeaderBox>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "10px",
          padding: "10px"
        }}
      >
        {videos.map((item: any, index: number) => (
          <>

            <div key={index} style={{ textAlign: "center" }} onClick={() => {setShowDownloadPopup(true);setOpenModal(true); setVideoId(item?.categoryHash); setVideoTitle(item?.name);setVideoObjId(item?.id); }}>
              <img
                
                src={`https://img.youtube.com/vi/${item.categoryHash}/maxresdefault.jpg`}
                style={{ width: "100%", borderRadius: "8px" }}
              />
              <p style={{ margin: "0 auto", fontWeight: 600 }}>{item?.name}</p>
            </div>
          </>
        ))}

      </div>
      {/* <Modal
        style={{ width: window.innerWidth }}

        open={openModal}

        onClose={(event, reason) => {
          if (reason === "backdropClick") return;
          setOpenModal(false);
        }}

        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper
          sx={{
            position: "relative",
            width: window.innerWidth,

            p: 1,
            outline: "none",

          }}
        >

          <IconButton
            onClick={() => setOpenModal(false)}
            sx={{
              position: "absolute",
              top: -10,
              right: 0,
              color: 'red',
              backgroundColor: "white",
              padding: '2px 2px 2px 2px',
              boxShadow: "0 3px 6px rgba(0,0,0,0.16), 0 1px 3px rgba(0,0,0,0.23)",
              transition: "transform 0.1s ease-in-out",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0 6px 12px rgba(0,0,0,0.2), 0 2px 4px rgba(0,0,0,0.18)"
              }
            }}
          >
            <CloseIcon />
          </IconButton>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <YouTube
              videoId={videoId}
              className="youtube-frame"
              opts={{
                width: window.innerWidth * 0.976,
                height: ((window.innerWidth / 16) * 9) * 0.976,
                playerVars: {
                  autoplay: 1,
                  rel: 0
                },
              }}
            />
          </div>
          <p style={{ fontSize: "18px", marginBottom: '-9px' }}>{videoTitle}</p>
          <hr style={{ backgroundColor: "black", marginLeft: '-8px', marginRight: '-8px', marginBottom: '10px', marginTop: '10px' }} />
          <div style={{ display: 'flex' ,justifyContent:'space-between'}}>
            <div>

              <img src={gitasevalogo} height={35} width={35} style={{ borderRadius: '50%' }} />
            </div>
            <div style={{position:'absolute',left:'12%',top:"88%",fontSize:'17px'}}>
              {t("Gita_Seva")}
            </div>
       <Snackbar
        open={snackOpen}
        autoHideDuration={3000}
        onClose={() => setSnackOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        message={likedMsg ? t("videoLiked_tr") : t("videoDislike_tr")}
        ContentProps={{
          style: {
            backgroundColor: "rgba(0,0,0,0.8)",
            color: "#fff",
            fontSize: "12px",
            fontWeight: 500,
            borderRadius: "8px",
          },
        }}
      />
            <div style={{padding:5}}>
              <img src={isLiked ? Favfill : favourite} height={30} width={30} className="mx-1" onClick={handleFavouriteClick}/>
              <img src={share} height={30} width={30} className="mx-1"/>
              <img src={whatsapp} height={30} width={30} className="mx-1"/>
            </div>
  
          </div>
        </Paper>
      </Modal> */}



    </>
  );
};

export default MbAllVideos;
